import { Document as PDFDocument } from '@react-pdf/renderer';

import { PropsWithChildren } from 'react';

import { IsPDFContext } from './internal/IsPDFContext.js';

export function Document(props: PropsWithChildren) {
  const { children } = props;
  return (
    <PDFDocument>
      <IsPDFContext.Provider value={true}>{children}</IsPDFContext.Provider>
    </PDFDocument>
  );
}
